<template>
  <div class="mdc-card">
    <slot/>
  </div>
</template>

<script>
import { MDCRipple } from '@material/ripple'

export default {
  name: 'mdc-card',

  mounted () {
    this.fabRipple = MDCRipple.attachTo(this.$el)
  },

  methods: {
    onClick () {
      this.$emit('click')
    }
  }
}
</script>
